import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { tv } from "tailwind-variants";
import cn from "../../../utils/cn";
const menuIconVariants = tv({
    base: "flex h-4 w-4 flex-row items-center justify-center transition-all duration-500 ease-in-out",
    variants: {
        type: {
            contained: "rounded-md bg-gray-3 group-hover:bg-gray-4",
            ghost: "",
        },
    },
    defaultVariants: {
        type: "ghost",
    },
});
const MenuIcon = ({ icon, type, className }) => {
    const customIcon = React.cloneElement(icon, {
        className: cn("text-current w-4 h-4", icon.props.className),
    });
    return _jsx("div", { className: cn(menuIconVariants({ type }), className), children: customIcon });
};
export default MenuIcon;
